// src/components/cookie-banner.js (JS or TS works)
import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { CookieNotice } from 'gatsby-cookie-notice';

const CookieBanner = () => {
	const SITE_KEY = process.env.GATSBY_SITE_KEY || 'uk';
	const LOCALE = (process.env.GATSBY_SITE_LOCALE || '').toLowerCase();
	const IS_DE = SITE_KEY === 'de' || LOCALE.startsWith('de');

	const cookieData = useStaticQuery(graphql`
		{
			cookieBannerUK: datoCmsConfig(locale: "en") {
				cookieBannerAccept
				cookieBannerBody
				cookieBannerCustomise
				cookieBannerDecline
				cookieBannerFbpBody
				cookieBannerFbpTitle
				cookieBannerGaBody
				cookieBannerGaTitle
				cookieBannerNecessaryBody
				cookieBannerNecessaryTitle
				cookieBannerTitle
			}
			cookieBannerDE: datoCmsConfig(locale: "de") {
				cookieBannerAccept
				cookieBannerBody
				cookieBannerCustomise
				cookieBannerDecline
				cookieBannerFbpBody
				cookieBannerFbpTitle
				cookieBannerGaBody
				cookieBannerGaTitle
				cookieBannerNecessaryBody
				cookieBannerNecessaryTitle
				cookieBannerTitle
			}
		}
	`);

	const data =
		(IS_DE ? cookieData.cookieBannerDE : cookieData.cookieBannerUK) ||
		cookieData.cookieBannerUK;
	return (
		<CookieNotice
			backgroundWrapperClasses='cookie-bg'
			backgroundClasses='cookie-inner background-white backdrop rounded-edges'
			wrapperClasses='cookie-container'
			buttonWrapperClasses='cookie-btn-wrapper'
			acceptButtonClasses='cookie-btn cookie-btn--accept'
			declineButtonClasses='cookie-btn cookie-btn--decline'
			personalizeButtonClasses='cookie-btn personalise-btn'
			personalizeValidationClasses='cookie-btn cookie-btn--accept'
			cookieMapClasses='cookie-item'
			personalizeButtonEnable={true}
			declineButton={false}
			acceptButtonText={data.cookieBannerAccept || 'Accept'}
			declineButtonText={data.cookieBannerDecline || 'Decline'}
			personalizeButtonText={data.cookieBannerCustomise || 'Customise'}
			cookieDays={365}
			cookies={[
				{
					name: 'necessary',
					editable: false,
					default: true,
					title:
						data.cookieBannerNecessaryTitle || 'Strictly necessary',
					text:
						data.cookieBannerNecessaryBody ||
						'Required for the site to function.',
				},
				{
					name: 'gdpr-ga',
					editable: true,
					default: false,
					title: data.cookieBannerGaTitle || 'Analytics',
					text:
						data.cookieBannerGaBody ||
						'Helps us understand site traffic (Google Analytics).',
				},
				{
					name: 'gdpr-fbp',
					editable: true,
					default: false,
					title: data.cookieBannerFbpTitle || 'Marketing',
					text:
						data.cookieBannerFbpBody ||
						'Used for personalised ads (Meta Pixel).',
				},
			]}
		>
			<h2>{data.cookieBannerTitle}</h2>
			<p>{data.cookieBannerBody}</p>
		</CookieNotice>
	);
};

export default CookieBanner;
